import type { Translations } from './ru';

export const pl: Translations = {
  header: {
    nav: {
      howItWorks: 'Jak to działa',
      example:    'Przykładowy raport',
      faq:        'FAQ',
    },
    cta: 'Poznaj swój plan',
  },

  footer: {
    tagline: 'Czytamy etykiety Twoich kosmetyków i układamy pielęgnację dopasowaną do Twojej skóry — bez zbędnych aktywów i wydatków.',
    nav:     'Nawigacja',
    contact: 'Kontakt',
    privacy: 'Prywatność',
    copyright: '© {year} SkinBloom · Personalna analiza pielęgnacji',
    disclaimer: 'Nie zastępuje konsultacji u dermatologa',
    links: {
      howItWorks: 'Jak to działa',
      example:    'Przykładowy raport',
      whyBetter:  'Dlaczego my',
      faq:        'FAQ',
    },
  },

  hero: {
    badge: 'Pielęgnacja personalna · $4.99 · 100% zwrot',
    headline: ['Plan pielęgnacji', 'dla Twojej skóry —', 'z uwzględnieniem Twoich kosmetyków.'],
    subhead:  'Pokaż nam swoje słoiczki — sprawdzimy, co zostawić, co zamienić i czego brakuje. Plan trafi na e-mail w 5 minut.',
    ctaPrimary:   'Poznaj swój plan',
    ctaSecondary: 'Zobacz przykład',
    trustCount:   '12 000+ stworzonych planów',
    badges: {
      private: 'Poufnie',
      email:   'Na e-mail',
      time:    '5 minut',
    },
    cards: {
      skinType: {
        label: 'TYP SKÓRY',
        value: 'Mieszana,\nwrażliwa',
      },
      actives: {
        label: 'AKTYWY',
        items: ['Niacynamid', 'Ceramidy', 'Kwas hialuronowy'],
      },
      plan: {
        label: 'PLAN PIELĘGNACJI',
        text:  'Rano · Wieczorem · 5 kroków',
      },
      report: {
        title:  'Tworzymy raport',
        status: 'Już prawie!',
      },
    },
  },

  problem: {
    titleA: 'Kosmetyków jest dużo.',
    titleB: 'Jasności — mało.',
    cards: [
      { title: 'Kupujesz po recenzjach',                   text: 'Ale czy to pasuje właśnie Twojej skórze — nikt nie powiedział.' },
      { title: 'Składy jak obcy język',                     text: 'Kwasy, retinol, ceramidy, niacynamid. Co z czym łączyć — niejasne.' },
      { title: 'Półka rośnie, porządku brak',              text: 'Rano przed lustrem nadal nie wiesz, co nakładać pierwsze i po co.' },
    ],
  },

  preview: {
    eyebrow:  'Przykładowy raport',
    titleA:   'Oto co dostaniesz',
    titleB:   'po analizie',
    subtitle: 'Nie ogólne porady, a konkretny plan: co zostawić, co odstawić, co dokupić i jak stosować.',
    moreNote: 'W pełnym raporcie — to plus 5 kolejnych sekcji: szczegółowy plan, rozbiór po etapach, prognoza efektów i rekomendacje.',
    ctaPrimary: 'Chcę taki plan',
    ctaOverlay: 'Zobacz pełny przykład raportu',

    swaps: {
      title: 'Analiza Twoich kosmetyków',
      rows: [
        { from: 'TO Niacinamide 10% + Zinc',  to: 'G&G Stress Less',          note: '10% to za mocno na wrażliwą skórę' },
        { from: 'CeraVe Hydrating Cleanser',  to: 'CeraVe Hydrating Cleanser',  note: 'Pasuje — zostaje' },
        { from: null,                          to: 'Balea Panthenol Serum',     note: 'Potrzebny do odbudowy bariery' },
      ],
      missing: 'Brakuje w Twojej rutynie',
    },

    ingredients: {
      title: 'Składniki dla Twojej skóry',
      items: [
        { name: 'Niacynamid 2–5%',         reason: 'Łagodzi zaczerwienienia, wzmacnia barierę' },
        { name: 'Ceramidy + cholesterol',  reason: 'Odbudowują warstwę ochronną skóry' },
        { name: 'Pantenol (B5)',           reason: 'Łagodzi podrażnienia, przywraca komfort' },
        { name: 'Kwas hialuronowy',        reason: 'Zatrzymuje wilgoć — przeciw uczuciu ściągnięcia' },
      ],
      caption: 'Stężenia i połączenia dobrane pod skórę wrażliwą z zaczerwienieniami.',
    },

    routine: {
      title: 'Plan pielęgnacji',
      tabs:  { morning: 'Rano', evening: 'Wieczór' },
      steps: {
        morning: ['Oczyszczanie', 'Niacynamid', 'Nawilżenie', 'SPF'],
        evening: ['Oczyszczanie', 'Pantenol', 'Krem', 'Naprawa'],
      },
    },

    timeline: {
      title: 'Kiedy zobaczysz efekty',
      steps: [
        { period: '1–2 tyg.', text: 'Mniej ściągnięcia, skóra wygląda spokojniej' },
        { period: '4 tyg.',   text: 'Zaczerwienienia mniej widoczne, skóra równiejsza' },
        { period: '6–8 tyg.', text: 'Bariera odbudowana, stan stabilny' },
      ],
    },
  },

  status: {
    ok:      'Pasuje',
    replace: 'Zamień',
    missing: 'Brak',
  },

  howItWorks: {
    titleA: 'Jak z chaosu powstaje',
    titleB: 'jasny plan',
    flow:   ['Twoje kosmetyki', 'Analiza składu', 'Plan pielęgnacji'],
    steps: [
      { n: '01', title: 'Opowiedz o skórze i pokaż słoiczki', text: 'Typ skóry, problemy, cele i to, co już stoi na półce. Tekstem albo zdjęciem.' },
      { n: '02', title: 'Czytamy każdą etykietę',                  text: 'Sprawdzamy, co pasuje Twojej skórze, co się dubluje, co drażni i czego brakuje.' },
      { n: '03', title: 'Dostajesz plan — krok po kroku',         text: 'Co zostawić, odstawić, dokupić — i jak stosować rano i wieczorem.' },
    ],
  },

  whyBetter: {
    titleA: 'Nie kolejny artykuł z internetu.',
    titleB: 'Plan dopasowany do Twojej skóry.',
    cards: [
      { title: 'Bez ślepego podążania za trendami', text: 'Patrzymy na Twoją skórę i skład — nie na popularność produktu.' },
      { title: 'Nie musisz kupować wszystkiego od nowa', text: 'Najpierw sprawdzamy, co z Twojej rutyny może zostać.' },
      { title: 'Bez zbędnych aktywów',               text: 'Pokazujemy, czego naprawdę potrzebujesz, a co tylko podrażni.' },
      { title: 'Jasna instrukcja',                    text: 'Rano, wieczór, częstotliwość i konkretne wskazówki.' },
    ],
    tagline: 'SkinBloom nie namawia, byś wyrzuciła półkę. Pomagamy zobaczyć, co już działa — i czego naprawdę brakuje.',
  },

  trust: {
    titleA: 'Uczciwie, jasno',
    titleB: 'i bez pustych obietnic',
    cards: [
      { title: 'Nie zastępuje dermatologa',         text: 'Jeśli masz chorobę skóry, lepiej zgłoś się do lekarza.' },
      { title: 'Nie wymusza nowych zakupów',        text: 'Najpierw analizujemy to, co już masz.' },
      { title: 'Skupiamy się na składzie',           text: 'Patrzymy na aktywy, stężenia, kompatybilność i potencjalne drażniące składniki.' },
      { title: 'Dane pozostają poufne',              text: 'Wykorzystujemy je tylko do stworzenia Twojego raportu.' },
    ],
  },

  planSection: {
    titleA:   'Zacznijmy od Twojej skóry',
    subtitle: 'Kilka pytań — i za parę minut wyślemy gotowy plan na e-mail.',
  },

  faq: {
    title: 'Najczęstsze pytania',
    items: [
      { q: 'Czy to zastępuje dermatologa?',
        a: 'Nie. SkinBloom to narzędzie do analizy składu i ułożenia indywidualnej pielęgnacji. Jeśli masz chorobę skóry (trądzik, trądzik różowaty, egzema), zgłoś się do dermatologa.' },
      { q: 'Czy muszę kupić nowe kosmetyki?',
        a: 'Niekoniecznie. Najpierw analizujemy to, co już masz, i pokazujemy, co może zostać. Zamiany rekomendujemy tylko tam, gdzie produkt naprawdę nie pasuje.' },
      { q: 'Czy mogę uwzględnić kosmetyki, które już mam w domu?',
        a: 'Tak — na tym właśnie polega analiza. Wpisujesz to, czego używasz, a my mówimy, co Ci pasuje, co warto wymienić i czego brakuje.' },
      { q: 'Co znajdę w raporcie?',
        a: 'Personalny profil skóry, plan na rano i wieczór, sprawdzenie kompatybilności aktywów, listę składników — co stosować i czego unikać — oraz konkretne propozycje produktów.' },
      { q: 'Kiedy dostanę plan?',
        a: 'Raport powstaje na podstawie Twoich odpowiedzi i zazwyczaj jest gotowy zaraz po wypełnieniu formularza. Wysyłamy go e-mailem.' },
      { q: 'Co, jeśli nie znam swojego typu skóry?',
        a: 'Spokojnie. W formularzu są podpowiedzi i pytania pomocnicze, które pozwalają określić typ po objawach. Wybierz „Nie wiem" — pomożemy się zorientować.' },
      { q: 'Czy to zadziała przy skórze wrażliwej?',
        a: 'Szczególnie tak. Przy wrażliwej skórze ważne jest, które aktywy pasują, a które mogą drażnić. Analiza pomaga uniknąć tych drugich i wybrać łagodne, ale skuteczne opcje.' },
    ],
  },

  finalCta: {
    eyebrow: '5 minut — i plan jest u Ciebie',
    titleA:  'Pora ogarnąć',
    titleB:  'swoją kosmetyczkę',
    body:    '5 minut — i w skrzynce leży plan dopasowany do Twojej skóry.\nNie porady z internetu, a konkretne kroki dla Twojego składu.',
    cta:     'Odbierz mój plan',
    trust:   '12 000+ stworzonych planów',
  },

  form: {
    pageH1A:    'Stwórzmy Twoją',
    pageH1B:    'personalną pielęgnację',
    pageSub:    'Opowiedz o sobie, a my zajmiemy się resztą.',
    progress:   'Postęp',
    stepLabel:  'Krok {n} z {total}',
    back:       'Wstecz',
    next:       'Dalej',
    submit:     'Stwórz mój plan — {price}',
    fineprint:  'Poufnie · Plan na e-mail · 100% zwrot, jeśli nie zadziała',

    skinTypes: {
      dry: 'Sucha', oily: 'Tłusta', combo: 'Mieszana',
      sensitive: 'Wrażliwa', unknown: 'Nie wiem',
    },

    skin: {
      eyebrowSkinType: 'Typ skóry: {type}',
      title:           'Opowiedz trochę o swojej skórze',
      subtitle:        'Typ, stan, co lubisz, czego nie — im więcej szczegółów, tym lepszy plan.',
      placeholder:     'Na przykład: skóra sucha, rano czuję ściągnięcie, czasem pojawiają się zaczerwienienia na policzkach.',
      hint:            'Wystarczy parę słów. Im więcej szczegółów, tym lepiej.',
    },

    allergies: {
      title:        'Jakieś alergie lub ograniczenia?',
      subtitle:     'Żebyśmy mogli je dokładnie wykluczyć z planu.',
      yes:          'Tak, mam',
      no:           'Nie, wszystko ok',
      labelDetails: 'Na co masz alergię?',
      placeholder:  'Na przykład: witamina C, olejki eteryczne, orzechy...',
      okMessage:    'Świetnie — pomijamy ten krok.',
    },

    products: {
      title:           'Opowiesz o aktualnych kosmetykach?',
      subtitle:        'Wpisz tekstem, dodaj zdjęcie albo zostaw puste.',
      labelText:       'Wymień kosmetyki',
      placeholderText: 'Na przykład: żel CeraVe, krem La Roche-Posay, serum z witaminą C...',
      orDivider:       'i / albo',
      labelPhoto:      'Wgraj zdjęcie',
      dropzonePrompt:  'Przeciągnij zdjęcie lub wybierz plik',
      removeFile:      'Usuń plik',
      hint:            'Możesz zrobić jedno zdjęcie wszystkich słoiczków — najważniejsze, żeby nazwy były czytelne.',
    },

    contact: {
      title:       'Gdzie wysłać gotowy plan?',
      subtitle:    'E-mail — wyślemy raport w ciągu kilku minut.',
      placeholder: 'example@gmail.com',
      hint:        'Tylko po to, żeby wysłać raport. Bez spamu.',
    },

    loading: {
      title:    'Analizujemy Twój profil skóry…',
      subtitle: 'To zajmie tylko chwilę.',
    },

    limit: {
      titleA:   'Osiągnęliśmy limit',
      titleB:   'nowych zgłoszeń',
      body:     'Algorytm tymczasowo nie przyjmuje nowych zapytań ze względu na duży ruch. Niedługo wracamy — zajrzyj później 🧡',
      cta:      'Wróć na stronę główną',
      footer:   'Damy znać na stronie, kiedy znów otworzymy zapisy na nowe plany.',
    },
  },

  example: {
    backHome: 'Wróć na stronę główną',
    eyebrow:  'Raport personalny',
    title:    'Przykładowy raport SkinBloom',
    subtitle: 'Powstał na podstawie analizy Twojej skóry i odpowiedzi z formularza.',
    meta: {
      date:   'Data utworzenia',
      dateValue: '24 maja 2024',
      id:     'ID raportu',
      idValue: 'SB-240524-001',
    },
    score: {
      label:    'Ogólny indeks skóry',
      good:     'Świetnie',
      heading:  'Twoja skóra jest w dobrej kondycji',
      body:     'Kontynuuj obecną pielęgnację i zwróć uwagę na obszary do poprawy.',
      scale:    ['Niski', 'Średni', 'Świetny'],
    },
    sections: {
      analysis:    'Analiza Twojej skóry',
      recommendations: 'Rekomendacje składu i produktów',
      detailedPlan:    'Szczegółowy plan',
      stages:          'Produkty według etapów',
      forecast:        'Spodziewane zmiany',
    },
    profile: {
      title: 'Profil skóry',
      rows: [
        { label: 'Typ skóry',        value: 'Sucha' },
        { label: 'Wrażliwość',       value: 'Wysoka' },
        { label: 'Zaczerwienienia',  value: 'Na policzkach' },
        { label: 'Ściągnięcie',      value: 'Po umyciu' },
        { label: 'Reaktywność',      value: 'Na aktywy' },
      ],
    },
    zones: {
      title: 'Obszary do poprawy',
      sub:   'Na czym skupia się plan',
      items: ['Zaczerwienienia', 'Ściągnięcie', 'Bariera skóry', 'Wrażliwość'],
      tipLabel: 'Wskazówka:',
      tipBody:  'łagodne oczyszczanie i krem odbudowujący barierę pomagają od razu we wszystkich obszarach.',
    },
    carePlan: {
      title:   'Plan pielęgnacji',
      sub:     'Rano · Wieczór',
      steps:   ['Oczyszczanie', 'Niacynamid', 'Nawilżenie', 'SPF'],
      cta:     'Zobacz pełny plan',
    },
    ingredients: {
      title: 'Kluczowe składniki',
      items: [
        { name: 'Niacynamid (2–5%)',  note: 'Łagodzi zaczerwienienia, wzmacnia barierę' },
        { name: 'Ceramidy',            note: 'Odbudowują warstwę ochronną' },
        { name: 'Kwas hialuronowy',    note: 'Nawilża, łagodzi ściągnięcie' },
        { name: 'Pantenol (B5)',       note: 'Łagodzi podrażnienia' },
      ],
      extra: '+ Glukonian cynku — przy okazjonalnych wypryskach',
    },
    productRecs: {
      title: 'Wymaga zamiany',
      swaps: [
        { from: 'TO Niacinamide 10% + Zinc',   to: 'Geek & Gorgeous Stress Less' },
        { from: 'La Roche-Posay Effaclar H',   to: 'LRP Cicaplast B5 Light' },
        { from: null,                           to: 'Balea Panthenol Serum' },
        { from: null,                           to: 'TO Ascorbyl Glucoside' },
      ],
    },
    tips: {
      title: 'Wskazówki i rekomendacje',
      items: [
        'Stosuj SPF codziennie, nawet zimą',
        'Nie pomijaj nawilżenia — bariera tego potrzebuje',
        'Unikaj niacynamidu 10%+ przy skórze wrażliwej',
        'Wprowadzaj nowe kosmetyki pojedynczo, co dwa tygodnie',
        'Łagodna witamina C — rano, trzy razy w tygodniu',
      ],
    },
    detailed: {
      eyebrow: 'Krok po kroku',
      heading: 'Twój finalny plan pielęgnacji',
      tabs: { morning: 'Rano', evening: 'Wieczór', weekly: 'Tygodniowo' },
      stepTitles: {
        cleanse:     'Oczyszczanie',
        niacin:      'Niacynamid 2–5%',
        moisturise:  'Nawilżenie',
        spf:         'SPF',
        panthenol:   'Pantenol (2–5%)',
        creamRepair: 'Krem regenerujący',
        vitaminC:    'Pon/Śr/Pt — Witamina C',
      },
      productNotes: {
        niacin10Strong:  'TO Niacinamide 10% — za mocny',
        effaclarMorning: 'Effaclar H — nie pasuje',
        effaclarEvening: 'Effaclar H — niewystarczający',
      },
    },
    stage: {
      shouldHave: 'Powinno być',
      avoid:      'Unikać',
      yourProducts: 'Twoje kosmetyki',
      examples:     'Przykładowe produkty',
      noProduct:    'Brak odpowiedniego produktu',
      stages: [
        {
          title: 'Oczyszczanie (rano i wieczorem)',
          shouldHave: ['Łagodne surfaktanty', 'Bez alkoholu i zapachu', 'Ceramidy / gliceryna / aminokwasy'],
          avoid: ['Toniki kwasowe', 'Mocne żele dla skóry problematycznej', 'Silnie pieniące formuły'],
          yourProducts: [{ name: 'CeraVe Hydrating Cleanser', ok: true }, { name: 'Pixi Glow Tonic', ok: false }],
          examples: [
            { tier: 'Budżet',   items: ['CeraVe Hydrating Cleanser', 'Simple Refreshing Facial Wash'] },
            { tier: 'Średnia',   items: ['LRP Toleriane Dermo Cleanser', 'Bioderma Sensibio Foaming Gel'] },
          ],
        },
        {
          title: 'Niacynamid (rano)',
          shouldHave: ['Stężenie 2–5%', 'Bez cynku albo minimum', 'Składniki łagodzące'],
          avoid: ['Stężenia 10%+', 'Połączenia z kwasami', 'Formuły szczypiące'],
          yourProducts: [{ name: 'TO Niacinamide 10% + Zinc', ok: false }],
          examples: [
            { tier: 'Budżet',   items: ['TO Niacinamide 5%', 'Revolution 2% Niacinamide'] },
            { tier: 'Średnia',   items: ['G&G Stress Less', 'LRP Mela B3'] },
          ],
        },
        {
          title: 'Nawilżenie (rano i wieczorem)',
          shouldHave: ['Ceramidy', 'Cholesterol', 'Kwasy tłuszczowe', 'Lekka tekstura'],
          avoid: ['Formuły dla skóry tłustej', 'Alkohole', 'Składniki kwasowe'],
          yourProducts: [{ name: 'La Roche-Posay Effaclar H', ok: false }],
          examples: [
            { tier: 'Budżet',   items: ['CeraVe Moisturising Cream', 'Balea Cica Cream'] },
            { tier: 'Średnia',   items: ['LRP Cicaplast B5 Light', 'Bioderma Atoderm Gel-Crème'] },
          ],
        },
        {
          title: 'SPF (rano)',
          shouldHave: ['SPF 50', 'Lekka tekstura', 'Bez zapachu', 'Pasuje do skóry wrażliwej'],
          avoid: [],
          yourProducts: [{ name: 'Garnier Ambre Solaire Fluid SPF50', ok: true }],
          examples: [
            { tier: 'Średnia', items: ['LRP UVMune 400'] },
            { tier: 'Premium',  items: ['SkinCeuticals Ultra Facial Defense'] },
          ],
        },
        {
          title: 'Pantenol (wieczorem)',
          shouldHave: ['2–5% pantenolu', 'Bez alkoholu', 'Bez kwasów'],
          avoid: [],
          yourProducts: [],
          examples: [
            { tier: 'Budżet',   items: ['Balea Panthenol Serum'] },
            { tier: 'Średnia',   items: ['LRP Cicaplast B5 Serum'] },
          ],
        },
        {
          title: 'Witamina C (w wybrane poranki)',
          shouldHave: ['Stabilne formy (SAP/MAP/AG)', 'Stężenie 5–10%', 'Bez drażniących dodatków'],
          avoid: [],
          yourProducts: [],
          examples: [
            { tier: 'Budżet',   items: ['TO Ascorbyl Glucoside 12%'] },
            { tier: 'Średnia',   items: ['G&G C-Glow'] },
          ],
        },
      ],
    },
    timeline: {
      eyebrow: 'Przy trzymaniu się planu',
      heading: 'Spodziewane zmiany',
      steps: [
        { period: '1–2 tygodnie', num: '01', items: ['Mniej ściągnięcia', 'Skóra wygląda spokojniej'] },
        { period: '4 tygodnie',   num: '02', items: ['Zaczerwienienia mniej widoczne', 'Skóra gładsza i równiejsza'] },
        { period: '6–8 tygodni',  num: '03', items: ['Bariera odbudowana', 'Mniejsza wrażliwość', 'Skóra w stabilnym stanie'] },
      ],
    },
    finalCta: {
      eyebrow: 'Plan personalny',
      heading: 'Chcesz swój własny plan?',
      body:    'Wyżej widzisz przykładowy raport. Twój zostanie ułożony pod Twoją skórę i kosmetyki.',
      cta:     'Odbierz plan pielęgnacji',
    },
    confidential: 'Raport jest poufny — dostęp masz tylko Ty',
  },
};
